<template>
  <div class="search-direction">
    <div class="field-type" style="padding-bottom:0px;">
      <span class="label">寻访方向:</span>
      <div :class="[project['寻访方向']?'':'gray-text','value project-pre']">
        <p v-if="project['寻访方向']">{{project['寻访方向']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('寻访方向')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div v-for="field in ['目标公司','不倾向公司']" :key="field" class="field-type" style="padding-bottom:0px;">
      <div class="field-type-tag">
        <span class="label">{{field}}:</span>
        <div v-if="project[field]&&project[field].length>0"
            class="flex-row flex-wrap full-width">
          <span
            v-for="item in project[field]"
            :key="item"
            :style="`margin: 0px 5px 5px 0;line-height: 22px;color:${companyTagMap[field]}`"
          >{{item}}</span>
        </div>
        <div v-else class="flex-row flex-wrap full-width">
          <span style="margin: 0px 5px 5px 0;line-height: 22px;color:#000">--</span>
        </div>
      </div>
    </div>
    <div class="field-type">
      <div class="field-type-tag">
        <span class="label">典型人才:</span>
        <div
          v-if="project.typicalRadishes&&project.typicalRadishes.length>0"
          class="flex-row flex-wrap full-width"
        >
          <span
            v-for="item in project['typicalRadishes']"
            :key="item._id"
            :style="`margin: 0px 5px 5px 0;line-height: 22px;cursor:pointer;color:#409EFF`"
            @click="showRadish({ id: item._id })"
          >{{item.姓名}}</span>
        </div>
        <div
          v-else
          class="flex-row flex-wrap full-width"
        >
          <span style="margin: 0px 5px 5px 0;line-height: 22px;color:#000">--</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['寻访方向', '目标公司', '不倾向公司',  '典型人才'],
      translateTag:{},
      companyTagMap:{
        '目标公司':'#409EFF',
        '不倾向公司':'#E6A23C',
        '勿推荐公司':'#F56C6C',
      },
    }
  },
  methods: {
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    quickEdit(field){
      const { translateTag, project } = this
      this.$emit('quickEdit',{
        value: project[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          try {
            await app.service('project').modify({ id: this.project._id, param:{ [field]: v } })
            this.$message.success(`修改成功`)
            this.$set(this.project,field,v)
          } catch (error) {
            this.$message.error(`modify:${error.message}`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.search-direction .field-type {
  padding-top: 0;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
